var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/InvestmentAllocationConstants');
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var ApplicationActionConstants = require('../constants/ApplicationConstants.js');
var ApplicationActionTypes = ApplicationActionConstants.ActionTypes;
var _ = require('lodash');
var Products = require('../utils/Products.js');
var ActionTypes = Constants.ActionTypes;
var CHANGE_EVENT = 'change';
var ApplicationConstants = require('../constants/ApplicationConstants');
var PensionConstants = require('../constants/PensionTypeConstants.js');
var ErrorCodes = ApplicationConstants.ErrorCodes;
var ValidationTypes = ApplicationConstants.ValidationTypes;
var PensionConstants = require('../constants/PensionTypeConstants.js');
var PensionActionTypes = PensionConstants.ActionTypes;
var InvestmentAllocationStore = require('./InvestmentAllocationStore');

var _list = [],
    _filteredList = [],
    _selected = null,
    _modelPortfolioPlaceHolderMsg = '',    
    _isManagedAccount = false,
    _managedAccountName = '',
    _mPValidationType = null,
    _mPErrorCode = null,
    _pensionType = null,
    _cashBucket = ApplicationConstants.YesNoValues.NO;

//New function for Message/Disclaimer when a Managed Account/Model Portfolio is selected
function managedAccountOrModelPortfolio(isRemoved){
        if(isRemoved){
            _mPErrorCode = null;
            _mPValidationType = null;
        }else{
            _mPErrorCode = ErrorCodes.ManagedAccountOrModelPortfolios;
            _mPValidationType = ValidationTypes.Primary;
        }
}

// Method to load model portfolio list from mock API
function loadModelPortfolioList(list, msg) {
    _list = [];
    list.filter(x => x.funds != null && x.funds.length > 0).map(function (obj) {
        _list.push({ 
            value: obj.id, 
            label: obj.name, 
            investmentOptions: obj.funds, 
            isManagedAccount: obj.isManagedAccount, 
            validForPreRetirementBenefit: obj.validForPreRetirementBenefit,
            validForRetirementBenefit: obj.validForRetirementBenefit
          });
    });

    filterPortfolioList(_pensionType);
    _modelPortfolioPlaceHolderMsg = msg;
}

function filterPortfolioList(pensionType) {

    if(!pensionType) 
        _filteredList = _list.slice();
    else {         
        if (pensionType === PensionConstants.PensionTypeSelectionNames.PRE_RETIREMENT)
            _filteredList = _list.filter(x => x.validForPreRetirementBenefit === true);
        else
            _filteredList = _list.filter(x => x.validForRetirementBenefit === true);               
    }
}

// Method to set the currently selected model portfolio
function setSelected(index) {
    _selected = _filteredList[index].value;
    _isManagedAccount = _filteredList[index].isManagedAccount;
    _managedAccountName = _filteredList[index].label;
    managedAccountOrModelPortfolio(false);
}

// Remove selected model portfolio
function removeSelected(removed, investmentoptions, isFirstRateCashNonAutoRebalancing) {

    if (removed) {
        //for cash bucket strategy, if no individual non-cash options have been then we keep the managed fund.
        const hasIndividualInvestmentOptions = investmentoptions.some(x => (isFirstRateCashNonAutoRebalancing === ApplicationActionConstants.YesNoValues.YES && !x.cashOption && !x.isManagedAccountOrModelPortfolio));        
        let portfolioOptionsRemoved = false;
        
        if(_selected && !hasIndividualInvestmentOptions) {
            const selectModelPortfolio = _list.filter(x => x.value == _selected)[0];
           
            if(isFirstRateCashNonAutoRebalancing === ApplicationActionConstants.YesNoValues.YES)
                portfolioOptionsRemoved = investmentoptions.filter(x => x.isManagedAccountOrModelPortfolio).length < selectModelPortfolio.investmentOptions.length;
            else
                portfolioOptionsRemoved = investmentoptions.length != selectModelPortfolio.investmentOptions.length;

            if(!portfolioOptionsRemoved && !investmentoptions.some(x => x.disabled))
            {
                for (let index = 0; index < selectModelPortfolio.investmentOptions.length; index++) {
                    const fund = selectModelPortfolio.investmentOptions[index];
                    const investmentOption = investmentoptions.filter(x => x.id === fund.id)[0];
                    
                    if(!fund || fund.weight !== +investmentOption.weight) {
                        portfolioOptionsRemoved = true;
                        break;
                    }
                    
                }
            }

        }
       
        if(hasIndividualInvestmentOptions || portfolioOptionsRemoved) {
            clearModelPortfolio();
            investmentoptions.forEach(x => {
                x.isManagedAccountOrModelPortfolio = false;
                x.disabled = false;
            })
        }
    }   
}

function setPensionTypeSelected(selectedPensionType) {

    if(_pensionType != null && selectedPensionType !== _pensionType && 
        (selectedPensionType === PensionConstants.PensionTypeSelectionNames.MORE || selectedPensionType === PensionConstants.PensionTypeSelectionNames.PRE_RETIREMENT || _pensionType === PensionConstants.PensionTypeSelectionNames.PRE_RETIREMENT)) {
        clearModelPortfolio();
    }

    _pensionType = selectedPensionType;
}

function clearModelPortfolio() {
    _selected = null;
    _isManagedAccount = false;
    _managedAccountName = '';
    managedAccountOrModelPortfolio(true);
}

function setCashBucket(value) {

    if(value !== _cashBucket) {
        _cashBucket = value;

        if(value === ApplicationConstants.YesNoValues.NO)  {            
            removeSelected(true, InvestmentAllocationStore.getList(), value);
        }
    }
}

//Method to get the current model portfolio Id
function setSelectedById(application) {
    var productId = _.get(application, 'productId');
    appInit(productId);

    var modelPortfolioId = _.get(application, 'form.investmentAllocation.modelPortfolioId');
    if (modelPortfolioId) {
        _selected = modelPortfolioId.toString();
    }
    var isManagedAccount = _.get(application, 'form.investmentAllocation.isManagedAccount');
    if (isManagedAccount) {
        _isManagedAccount = isManagedAccount;
    }
    var managedAccountName = _.get(application, 'form.investmentAllocation.managedAccountName');
    if (managedAccountName) {
        _managedAccountName = managedAccountName;
    }
    const pensionType = _.get(application, 'form.pensionType.selectedPensionType');
    if (pensionType) {
        _pensionType = pensionType;
    }

}

function appInit(productId) {
    _modelPortfolioPlaceHolderMsg = Products.isInvestment(productId)
        ? Constants.PlaceHolderMessage.INVESTMENT
        : Constants.PlaceHolderMessage.SUPER_PENSION;
}

var ModelPortfolioStore = assign({}, EventEmitter.prototype, {

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    /**
     * @param {function} callback
     */
    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },

    /**
     * @param {function} callback
     */
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },

    // Return Model Portfolio list
    getList: function () {
        return _filteredList;
    },

    // Return selected Model Portfolio
    getSelected: function () {
        return _selected;
    },

    getSelectedItem: function () {
        if(!_selected || !_filteredList.length) return null;
        return _filteredList.filter(x => x.value.toString() === _selected);
    },

    getPortfolioPlaceHolder: function () {
        return _modelPortfolioPlaceHolderMsg;
    },

    getPortfolioDisable: function () {
        if (_list.length > 0) {
            return false;
        } else {
            return true;
        }
    },
    getIsManagedAccount: function () {
        return _isManagedAccount;
    },
    getManagedAccountName: function () {
        return _managedAccountName;
    },

    getMpValidationType: function (){
        return _mPValidationType;
    },
    
    getMpValdationError: function (){
        return _mPErrorCode;
    },

    getPensionType: function (){
        return _pensionType;
    }

});

ModelPortfolioStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {

        case ActionTypes.RECEIVE_MODEL_PORTFOLIO_LIST:
            loadModelPortfolioList(action.modelPortfolioList, action.message);
            break;
        case ActionTypes.SELECT_MODEL_PORTFOLIO:
            setSelected(action.index);
            break;
        case ActionTypes.REMOVE_SELECTED_PORTFOLIO_LIST:
            removeSelected(action.value, action.investmentOptions, action.isFirstRateCashNonAutoRebalancing);
            break;
        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            filterPortfolioList(action.applicationData.form && action.applicationData.form.pensionType ? action.applicationData.form.pensionType.selectedPensionType : null);
            setSelectedById(action.applicationData);
            break;
        case ApplicationActionTypes.NEW_APPLICATION_INITIALISED:
            appInit(action.productId);
            break;
        case PensionActionTypes.SELECT_PENSION_TYPE:
            filterPortfolioList(action.value);
            break;  
        case ApplicationActionTypes.IS_PENSION_TYPE_SELECTED:
            setPensionTypeSelected(action.selectedPensionType);
            break;    
        case ActionTypes.TOGGLE_FIRST_RATE_CASH_NON_AUTO_REBALANCING:
            setCashBucket(action.value);
            break;
        default:
            return true;
    }

    // If action was responded to, emit change event
    ModelPortfolioStore.emitChange();
    return true;

});

module.exports = ModelPortfolioStore;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/ModelPortfolioStore.js